import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AlertRequest } from '../../kitchen/shared/domain/alerts/alert-request.model';
import { WidgetType } from '../domain/widget-type.model';
import { HttpUtils } from '../utils/http-utils';

@Injectable()
export class AdStatsWidgetTypesService {
  widgetRequest: AlertRequest; //use this to communicate last request run on alerts widget before redirection to alerts component where it will be run again

  constructor(private http: HttpClient) {
  }

  // AD_STATS_WIDGET_TYPES_GET: 'GET /ad-stats/widget-types/{id}',
  // AD_STATS_WIDGET_TYPES_POST: 'POST /ad-stats/widget-types',
  // AD_STATS_WIDGET_TYPES_PUT: 'PUT /ad-stats/widget-types/{id}',

  getAll(filter?: { enabled?: boolean }): Observable<WidgetType[]> {
    return this.http.get<WidgetType[]>(`${environment.serviceUrl}/ad-stats/widget-types`, {
      params: filter ? HttpUtils.getHttpParams(filter) : null
    });
  }

  createWidgetType(widgetType: WidgetType): Observable<WidgetType> {
    return this.http.post<WidgetType>(`${environment.serviceUrl}/ad-stats/widget-types`, widgetType);
  }

  updateWidgetType(widgetType: WidgetType): Observable<WidgetType> {
    return this.http.put<WidgetType>(`${environment.serviceUrl}/ad-stats/widget-types/${widgetType.id}`, widgetType);
  }
}
